import LegalTenancyPage from './LegalTenancyPage';

const Terms = () => {
  return <LegalTenancyPage isTermsActive contentGroup="terms" />;
};

export { Terms };
